import React, { Component } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import Auxs from "src/Auxs";


/**
 * @desc step1802: 404 Page Component (NotFound Page)
 * @returns {Element}
 * @constructor
 */
class Page404 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }
  render() {
    return (
      <Auxs>
        <Helmet>
          <title>Page 404</title>
        </Helmet>
        <div className="container not_found">
          <h1>404</h1>
          <p>Oops! Something is wrong.</p>
          <Link to="/" className="button">
            <i className="icon-home"/> Go back in initial page, is better.
          </Link>
        </div>
      </Auxs>
    );
  }
}

export default Page404;
